import { useBranding } from "@/contexts/BrandingProvider";

/**
 * The owner's WhatsApp number when the floating WhatsApp button shows, null otherwise. The button
 * reads it to render itself; anything pinned to the bottom of the screen (the extras' sticky total
 * bar) reads it to keep clear of the button's corner. One rule, so the two cannot disagree.
 */
export function useFloatingWhatsapp(): string | null {
  const { branding, isBranded } = useBranding();
  if (!isBranded || !branding?.floatingWhatsappEnabled || !branding.contactWhatsapp) return null;
  return branding.contactWhatsapp;
}
